import React from "react";

export const TemplateThumbnail = ({ template }) => {
  return (
    <div className="w-full h-full relative">
      <img
        src={template.image}
        alt={template.name}
        className="w-full h-full object-cover"
        crossOrigin="anonymous"
        loading="lazy"
      />
    </div>
  );
};
